import { LayoutController } from "onearm";
import gsap from "gsap";
import { ImageNumbers } from "../../components/ImageNumbers.js";

export class LineWinDisplay extends LayoutController {
    init() {
        this.container = this.find("winContainer");

        const valueNode = this.find("winContainer.value");
        if (valueNode && this.options.resources) {
            const parent = valueNode.parent;
            parent.removeChild(valueNode);

            this.numbers = new ImageNumbers({ resources: this.options.resources, size: 100 });
            this.numbers.x = valueNode.x;
            this.numbers.y = valueNode.y - valueNode.height / 2;
            parent.addChild(this.numbers);
        }

        this.hide();
    }

    setValue(value) {
        this.numbers?.setValue(value);
    }

    fadeIn({ duration = 0.2 } = {}) {
        const tl = gsap.timeline();
        if (!this.container) return tl;
        tl.add(() => {
            this.container.alpha = 0;
            this.container.visible = true;
        });
        tl.to(this.container, { alpha: 1, duration, ease: "sine.out" });
        return tl;
    }

    fadeOut({ duration = 0.2 } = {}) {
        const tl = gsap.timeline();
        if (!this.container) return tl;
        tl.to(this.container, { alpha: 0, duration, ease: "sine.in" });
        tl.add(() => { this.container.visible = false; });
        return tl;
    }

    hide() {
        if (!this.container) return;
        gsap.killTweensOf(this.container);
        this.container.alpha = 0;
        this.container.visible = false;
    }

    onDestroy() {
        this.hide();
    }
}
